import { init_language } from '@/utils/language'

const config = {
  host  : window.location.hostname,
  lang  : init_language('en'),
  email : 'support@foundit.mobi',
  set_email (src: string): string {
    return src.replaceAll('support@foundit.mobi', this.email)
  },
  gtag: ''
}

export { config }
  
